const fallbackRoutes = {
  manager: '/admin/clients',
  admin: '/admin/managers',
  client: '/admin/404'
};

export default fallbackRoutes;
